import React from 'react';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import CtaButtonContainer from '../../../../components/elements/CtaButton/CtaButtonContainer';
import CtaButton from '../../../../components/elements/CtaButton';
import { botClassName } from '../../../../utils/e2eBotUtils';
import { HeroLeft, HeroRightImage, HeroTitle, HeroWrapper, ValueProps } from './components';
import { useIsMobile } from '../../../../hooks/screenSizeHooks'

const styles = require('./Hero.module.css');

function HeroDefault({ onCtaClick, data }) {
  const {
    title,
    valueProps,
    trialText,
    ctaLabel,
    heroImageDesktop,
    heroImageMobile,
    valuePropIcon,
  } = data;
  const heroImage = useIsMobile() ? heroImageMobile : heroImageDesktop;

  return (
    <HeroWrapper>
      <HeroLeft>
        <HeroTitle>{title}</HeroTitle>
        <ValueProps valuePropIcon={valuePropIcon} valueProps={valueProps} />
        <CtaButtonContainer className={styles.heroCtaContainer}>
          <CtaButton
            type="primary"
            data-event-action="homepage-header"
            data-event-label="Start Free Trial"
            onClick={onCtaClick}
            className={botClassName('hero-cta-btn')}
            fullWidthMobile
          >
            {ctaLabel}
          </CtaButton>
        </CtaButtonContainer>
        <CodeSparkThemedTypography variant="legal" className={styles.heroSectionTrialLegal}>
          {trialText}
        </CodeSparkThemedTypography>
      </HeroLeft>

      <HeroRightImage image={heroImage} />
    </HeroWrapper>
  );
}

export default HeroDefault;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/Hero/HeroDefault.js